<template>
    <!-- 微信支付成功 -->
    <div>
        <!-- v-show="$route.meta.showFather" -->
        <div class="pad-16 mb-16 box-shadow">
            <div class="is-flex mb-24">
                <div class="left-icon"></div>
                <p class="left-p">扫码支付</p>
            </div>
            <div class="is-flex jus-bet te-c">
                <div></div>
                <div>
                    <img src="../../../assets/expert/success.png" alt="" class="wxzf mb-16">
                    <p class="mb-16 net">可在<我的-我的活动-待参与>中查看</p>
                    <div class="is-flex zhifu">
                        <p @click="fanhui">返回</p>
                        <p @click="goDetails">查看详情</p>
                    </div>
                </div>
                <div></div>

            </div>
        </div>
        <div class="box-shadow pad-16 mb-16">
            <div class="is-flex jus-bet">
                <div class="">
                    <div class="is-flex mb-8">
                        <img src="../../../assets/myself/Framehui.png" alt="">
                        <p class="hui">《会员权益与义务告知书》</p>
                    </div>
                    <p class="tishi">开通会员后，请先下载告知书，加盖公章后进行上传</p>
                </div>
                <div class="download is-flex" @click="downLoad(content)">
                    <img src="../../../assets/myself/xiazai.png" alt="">
                    <p>下载</p>
                </div>
            </div>
        </div>
        <div class="box-shadow pad-1 mb-24">
            <div class="is-flex mb-24">
                <div class="left-icon"></div>
                <p class="left-p">上传告知书</p>
            </div>
            <div>
				<el-upload class="avatar-uploader" :action="imgBaseUrl +'/infra/file/upload'"
				    :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
				    <!-- 跨域访问后端的路径，action一定要加api；否则跨域访问会失败，然后就报错。 -->
				    <img :src="imageUrl?imageUrl:require('../../../assets/photo.png')" class="unPhoto mb-24" alt="">
				    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div> -->
				</el-upload>
                <!-- <img src="../../../assets/photo.png" class="unPhoto mb-24" alt=""> -->
                <!-- <el-upload class="avatar-uploader" action="" :show-file-list="false"
                        :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                        <img src="../../../assets/myself/photo.png" class="unPhoto mb-24" alt="">
                    </el-upload> -->
                <p class="tishi">上传后表明您已知晓会员权益和义务</p>
            </div>
        </div>
    </div>
</template>

<script>
	import {
	    getInvoiceList,
	    getAgreement,
		getMyLevel,
		getNotification
	} from '@/api/personal/api.js';
    export default {
        components: {},
        data() {
            return {
                infoShow: true,
                taus: '',
				content:'',
				imgBaseUrl: 'https://www.zgjyzjw.com/beishida/app-api',
				imageUrl: '',
				idUpdate: '',
				upImg:'../../../assets/photo.png'
            }
        },
        created() {

        },
        mounted() {
			this.getInit();
			this.getMyVIP() ;
		},
        methods: {
			getMyVIP() {
			    getMyLevel().then(res => {
			        this.idUpdate = res.data[0].id;
			    })
			},
			handleAvatarSuccess(res, file) {
			    console.log('res',res)
			    this.imageUrl = URL.createObjectURL(file.raw);
			    this.upDate(res.data);
			},
			beforeAvatarUpload(file) {
			    const isJPG = file.type === 'image/jpeg';
			    const isLt2M = file.size / 1024 / 1024 < 2;
			
			    if (!isJPG) {
			        this.$message.error('上传头像图片只能是 JPG 格式!');
			    }
			    if (!isLt2M) {
			        this.$message.error('上传头像图片大小不能超过 2MB!');
			    }
			    return isJPG && isLt2M;
			},
			upDate(notificationUrl) {
			    let params = {
			        id: this.idUpdate,
			        notificationUrl: notificationUrl
			    }
			    getNotification(params).then(res => {
			        console.log(res, '--')
			        if (res.code == 0) {
			            this.$message.success('上传成功')
			        }
			    })
			},
			getInit() {
			    getAgreement({
			        type: 3
			    }).then(res => {
			        console.log(res.data, '--')
			        this.docTitle = res.data.title;
			        localStorage.setItem('docTitle',this.docTitle)
			        this.content = res.data.content;
			    })
			},
			downLoad(content) {
			    window.open(content,'_blank')
			},
			goDetails(){
				this.$router.push("/personal/member/index");
			},
            fanhui() {
                this.$router.go(-2)

            },
        }
    }
</script>


<style scoped>
    .pad-16 {
        padding: 32px 16px;

    }

    .pad-1 {
        padding: 16px;
    }

    .box-shadow {
        box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .is-flex {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }


    .mb-24 {
        margin-bottom: 24px;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    .mb-8 {
        margin-bottom: 8px;
    }

    .left-icon {
        width: 6px;
        height: 20px;
        background: #3377FF;
        border-radius: 18px;
    }

    .left-p {
        font-size: 20px;
        color: #222222;
        font-weight: normal;
        padding-left: 10px;
    }

    .wxzf {
        width: 62px;
        height: 84px;
    }

    .te-c {
        text-align: center;
    }

    .net {
        color: #222222;
        font-size: 14px;
    }

    .zhifu p {
        font-size: 16px;
        border-radius: 4px 4px 4px 4px;
    }

    .zhifu p:first-child {
        background-color: #F0F5FF;
        color: #3377FF;
        margin-right: 16px;
        padding: 12px 74px;
    }

    .zhifu p:last-child {
        background-color: #3377FF;
        color: #FFFFFF;
        padding: 12px 58px;
    }

    .tishi {
        color: #FF4E33 !important;
    }

    .download {
        background: #F0F5FF;
        border-radius: 41px 41px 41px 41px;
        color: #3377FF;
        padding: 8px 16px;
    }

    .download img {
        width: 18px;
        height: 19px;
        padding-right: 8px;
    }

    .unPhoto {
        width: 88px;
        height: 88px;
    }
</style>
